import React, {useContext} from "react";
import './TotalRankingStyles.css'
import styled from "styled-components";

import {HorizontalSeparator} from "../separators/Separators";
import TabTitle from "../../components/tabTitle/TabTitle";
import {useTranslation} from "react-i18next";
import TotalRankingPillsComponent from "./components/TotalRankingPillComponent";
import {TotalRankingContainerProps} from "../../containers/totalRanking/TotalRankingContainer";
import TabFooter from "../tabFooter/TabFooter";
import {RegionSelectedContext} from "../../contexts/RegionSelectedContext";
import TwoColumnsLayout from "../TwoColumnsLayout/TwoColumnsLayout";
import Tab from "../tab/Tab";


const TotalRankingContent: React.FC<{ isTabSelected: boolean }> = ({ isTabSelected }) => {
  const { t } = useTranslation();
  const { regionSelected, yearSelected } = useContext(RegionSelectedContext);

  const currency = regionSelected === 'eu' ? 'M€' : 'M USD';

  return (
    <TwoColumnsLayout
      leftColumnChildren={
        <>
          <div className={'titleWrapperTR'}>
            <h3 className={'marginTop50'}>
              { t('totalRanking.subtitle', { currency }) }
            </h3>
            <HorizontalSeparator width={50}/>
          </div>
          <div className={'leftColumnContainer'}>
              <p className={'lineHeight1'}>
                  {t(`totalRanking.${ yearSelected.niiff ? "niif." : (regionSelected === "reaseguro" ? "re." : "") }paragraphContent`)}
              </p>
          </div>
        </>
      }
      rightColumnChildren={
        <div className={'rightColumnContainer'}>
          <TotalRankingPillsComponent active={ isTabSelected } />
        </div>
      }
    />
  );
};

const TotalRankingContentContainer = styled.div`
  align-self: center;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  height: 100%;
  width: 100%;

  @media (min-width: 481px) {
    flex-direction: row;

    /* Let the flex children shrink below their content's intrinsic width so the
       table never forces the whole tab wider than the available space. */
    > div,
    .left-column,
    .right-column,
    .rightColumnContainer {
      min-width: 0;
    }

    h3 {
      margin-top: 0px;
    }
  }

  /* NARROW DESKTOP / TABLET (481-1023px): the text and table get too cramped
     side by side, so stack them into a column and let the whole tab scroll. */
  @media (min-width: 481px) and (max-width: 1023px) {
    > div {
      flex-direction: column;
      gap: 40px;
    }
  }

  /* WIDE DESKTOP (>=1024px): text and table sit side by side. Fill the tab body
     exactly and clip overflow so only the rows scroll and the tab never does. */
  @media (min-width: 1024px) {
    min-height: 0;
    overflow: hidden;
    box-sizing: border-box;

    /* Let the flex height propagate down to the scrolling rows. */
    > * {
      min-height: 0;
    }

    .right-column {
      min-width: 350px;
      min-height: 0;
    }

    .rightColumnContainer {
      flex: 1;
      min-width: 350px;
      min-height: 0;
    }
  }
`;

const TotalRankingComponent: React.FC<TotalRankingContainerProps> = ({isTabSelected}) => {
    const {t} = useTranslation();

    // TODO: drop isTabSelected attribute from TabTitle
    const title = <TabTitle title={t('totalRanking.title')} isTabSelected={ isTabSelected }/>;
    const body = (
      <TotalRankingContentContainer>
        <TotalRankingContent isTabSelected={ isTabSelected } />
      </TotalRankingContentContainer>
    );
    const footer = <TabFooter/>;

    return (
      <Tab
        title={ title }
        body={ body }
        footer={ footer }
        isOpen={ isTabSelected }
      />
    );
};

export default TotalRankingComponent;
